import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useReturnTo } from '../../../hooks/useReturnTo';

// Api.
import AgentApi from '../../../api/instance/AgentApi';

// Context.
import { AgentContext } from '../../../context/AgentContext';

// Types.
import Action from '../../../types/Action';
import Agent from '../../../types/instance/Agent';

// Constants.
import { ACTIONS } from '../../../component/Constants';

// Components.
import Alert from '../../../component/Alert';

function Detail() {
    const returnFromForm = useReturnTo('/admin/agents');
    const { actionId, agentId } = useParams();
    const { agents, setAgents } = useContext(AgentContext);

    const [action, setAction] = useState<Action>(ACTIONS.DELETE);
    const [isMissing, setIsMissing] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [id, setId] = useState<number>(0);
    const [name, setName] = useState<string>('');
    const [datasourceCount, setDatasourceCount] = useState<number>(0);
    const [hostCount, setHostCount] = useState<number>(0);

    useEffect(() => {

        const getAgent = (agentId: number) => {

            const matchedAgent = agents.filter((agent: Agent) => agent.id === Number(agentId));

            if (matchedAgent.length === 1) {
                setId(matchedAgent[0].id);
                setName(matchedAgent[0].name);
                setDatasourceCount(matchedAgent[0].datasourceCount || 0);
                setHostCount(matchedAgent[0].hostCount || 0);
            } else {
                setIsMissing(true);
            }
        }

        const getAction = () => {

            switch (actionId) {


                case 'delete':

                    setAction(ACTIONS.DELETE);

                    break;

                default:

                    console.error('Unknown action requested', actionId);

                    setIsError(true);

                    break;
            }
        }

        getAction();

        if (agentId !== undefined) {
            getAgent(Number(agentId));
        }

    }, [agents, actionId, agentId]);

    async function handleActionClick() {

        // Check if agent is in use
        if (datasourceCount > 0 || hostCount > 0) {
            setIsError(true);
            return;
        }

        // Build the agent object.
        let data: Agent = {
            id,
            name
        };

        let result: any = undefined;

        // Delete the object.
        result = await AgentApi.deleteAgent(data);

        if (result.status === 200) {

            // Remove the object from the array.
            setAgents(agents.filter(object => Number(object.id) !== id));

            // Redirect the user back to the list view.
            returnFromForm();
        } else {

            // Failed to complete the API request.
            console.error('Failed to delete agent', result, data);

            // Failed to complete request.
            setIsError(true);
        }
    }

    return (
        <div className="col">
            <div className="card">
                <div className="card-header">
                    <i className="fal fa-light fa-circle-arrow-up-right fa-fw" aria-hidden="true"></i>
                    {action.title} agent
                </div>
                <div className="card-body">
                    {isMissing ? (
                        <React.Fragment>
                            <Alert message="The requested agent is either invalid or no longer available." heading="Invalid request" variant="alert-danger" />
                            <div className="row g-0 form">
                                <div className="col-xs-12 col-md-9 col-lg-6 actions">
                                    <Link to="/admin/agents/" role="button" className="btn btn-secondary"><i className="fal fa-arrow-circle-left fa-fw fa-sm"></i><span>Back</span></Link>
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>

                            {action.type === 'delete' && datasourceCount === 0 && hostCount === 0 && (
                                <Alert message="Deleting the agent will remove it from the list of agents but if the agent is still running or is restarted in the future it will re-register and show here again. Are you sure you would like to delete?" heading="Confirm Deletion" variant="alert-warning" />
                            )}

                            {action.type === 'delete' && (datasourceCount > 0 || hostCount > 0) && (
                                <Alert message={`This agent is used by ${datasourceCount} Datasource(s) and ${hostCount} Host(s) and cannot be deleted while it is still being used. Please either remove the Datasources or Hosts using it first, or switch them to use a different agent in order to delete this agent.`} heading="Cannot Delete Agent" variant="alert-danger" />
                            )}

                            {isError && datasourceCount === 0 && hostCount === 0 && (
                                <Alert message="Sorry, but something went wrong and the requested action failed.  If the issue persists, please raise a support request." heading={`Failed to ${action.title.toLowerCase()} agent`} variant="alert-danger" />
                            )}

                            <div className="row g-0">
                                <div className="col-12 actions text-end">
                                    <Link to="/admin/agents/" role="button" className="btn btn-secondary me-2"><i className="fal fa-times-circle fa-fw fa-sm"></i><span>Cancel</span></Link>
                                    {(datasourceCount === 0 && hostCount === 0) && (
                                        <button className={`btn btn-${action.variant}`} onClick={handleActionClick}><i className={`${action.icon} fa-sm`}></i><span>Confirm</span></button>
                                    )}
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Detail;